import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {CyClass} from '../../../../../common/cy-classes';
import {BurgerMenuContainerBox} from "./boxes/container/burger-menu-container.box";

export class MobileBurgerMenuComponent extends OrbitComponent<{}> {
  private _clickHandler = () => {
    this.services.analytics.sendOrbitUserFlowEvent("Navigation","NavBar", "Open_Burger");
    this.services.sideMenu.openMobileMenu();
  };

  private _getIcon() {
    if (this.services.abTestingFeatureDataProvider.mobileHeaderSearchButtonEnabled) {
      return this.services.theme.currentTheme.icons.mobileMenuNoSearchIcon;
    }
    return this.services.theme.currentTheme.icons.mobileMenuIcon;
  }

  render() {
    const MobileMenuIcon = this._getIcon();
    return (
        <BurgerMenuContainerBox  onClick={this._clickHandler}>
          <MobileMenuIcon className={`${CyClass('cy-burger-button')}`} size={3} />
        </BurgerMenuContainerBox>
    );
  }
}
